import { Link } from 'react-router-dom';

export default function PlanosHero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-luxury-black/90 backdrop-blur-md border-b border-gold-500/10">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 group">
              <img
                src="https://static.readdy.ai/image/9b313db6312c9605d9f9e3f145d3e29c/a68d70c6b66064870b0e9282c113321b.jpeg"
                alt="Bia Holmes"
                className="w-20 h-20 object-contain rounded-full bg-white p-0.5 flex-shrink-0 group-hover:scale-110 group-hover:drop-shadow-[0_0_14px_rgba(201,164,64,0.55)] transition-all duration-300"
              />
              <span className="text-xl font-bold bg-gradient-to-r from-gold-400 to-gold-600 bg-clip-text text-transparent font-['Playfair_Display'] hidden sm:block">
                Carta do Eu Futuro
              </span>
            </Link>
            <div className="flex items-center gap-2 sm:gap-4">
              <button
                onClick={() => scrollToSection('exercicios-pnl')}
                className="text-sm text-white/60 hover:text-gold-400 transition-colors font-['Montserrat'] whitespace-nowrap cursor-pointer hidden md:block"
              >
                Exercícios PNL
              </button>
              <button
                onClick={() => {
                  const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                  btn?.click();
                }}
                className="hidden sm:flex items-center gap-2 text-xs border border-gold-500/40 text-gold-400 hover:bg-gold-500/10 px-3 py-2 rounded-lg transition-all font-['Montserrat'] whitespace-nowrap cursor-pointer"
              >
                <i className="ri-customer-service-2-line text-sm"></i>
                <span className="hidden lg:inline">Falar com a Bia</span>
              </button>
              <Link to="/login" className="text-sm text-white/60 hover:text-gold-400 transition-colors font-['Montserrat'] whitespace-nowrap hidden sm:block">
                Entrar
              </Link>
              <Link to="/dashboard" className="px-3 sm:px-5 py-2 sm:py-2.5 bg-gradient-to-r from-gold-500 to-gold-700 text-luxury-black text-xs sm:text-sm font-semibold rounded-lg hover:shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all font-['Montserrat'] whitespace-nowrap">
                <span className="hidden sm:inline">Meu Painel</span>
                <span className="sm:hidden">Entrar</span>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="pt-32 pb-20 bg-luxury-black relative overflow-hidden">
        <div className="absolute top-40 left-20 w-72 h-72 bg-gold-500/5 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-20 right-20 w-64 h-64 bg-gold-500/5 rounded-full blur-[100px]"></div>
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>

        <div className="max-w-7xl mx-auto px-6 text-center relative z-10">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gold-500/40"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">
              Escolha Sua Experiência
            </span>
            <div className="w-12 h-px bg-gold-500/40"></div>
          </div>

          <h1 className="font-['Playfair_Display'] text-5xl md:text-6xl text-white mb-6 leading-tight">
            Planos para Cada Etapa da
            <span className="block text-gold-400 italic mt-2">Sua Jornada</span>
          </h1>

          <div className="flex justify-center mb-6">
            <div className="w-20 h-0.5 bg-gradient-to-r from-transparent via-gold-500 to-transparent"></div>
          </div>

          <p className="font-['Montserrat'] text-base text-white/50 max-w-3xl mx-auto mb-8 font-light tracking-wide leading-relaxed">
            Do primeiro passo gratuito até a transformação completa. Escolha o plano ideal para construir conscientemente o futuro que você deseja viver.
          </p>

          {/* Quick Navigation Links */}
          <div className="flex flex-wrap items-center justify-center gap-3 mt-10">
            <button
              onClick={() => scrollToSection('comparacao-planos')}
              className="px-4 py-2 bg-white/[0.05] border border-gold-500/20 rounded-lg text-white/70 hover:text-gold-400 hover:border-gold-500/40 transition-all font-['Montserrat'] text-xs whitespace-nowrap cursor-pointer"
            >
              <i className="ri-layout-grid-line mr-2"></i>Planos
            </button>
            <button
              onClick={() => scrollToSection('exercicios-pnl')}
              className="px-4 py-2 bg-white/[0.05] border border-gold-500/20 rounded-lg text-white/70 hover:text-gold-400 hover:border-gold-500/40 transition-all font-['Montserrat'] text-xs whitespace-nowrap cursor-pointer"
            >
              <i className="ri-brain-line mr-2"></i>Exercícios PNL
            </button>
            <button
              onClick={() => scrollToSection('exercicios-avulsos')}
              className="px-4 py-2 bg-white/[0.05] border border-gold-500/20 rounded-lg text-white/70 hover:text-gold-400 hover:border-gold-500/40 transition-all font-['Montserrat'] text-xs whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-line mr-2"></i>Avulsos
            </button>
            <button
              onClick={() => scrollToSection('meditacoes-guiadas')}
              className="px-4 py-2 bg-white/[0.05] border border-gold-500/20 rounded-lg text-white/70 hover:text-gold-400 hover:border-gold-500/40 transition-all font-['Montserrat'] text-xs whitespace-nowrap cursor-pointer"
            >
              <i className="ri-music-line mr-2"></i>Meditações
            </button>
            <button
              onClick={() => scrollToSection('experiencias-especiais')}
              className="px-4 py-2 bg-white/[0.05] border border-gold-500/20 rounded-lg text-white/70 hover:text-gold-400 hover:border-gold-500/40 transition-all font-['Montserrat'] text-xs whitespace-nowrap cursor-pointer"
            >
              <i className="ri-star-line mr-2"></i>Experiências
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
